export default function initBlogCopiarLink() {

    const copyBtn = document.querySelector('.j-copy-link');
    const trigger = document.querySelector('.c-compartilhar__trigger');
    const dropdown = document.querySelector('.c-compartilhar__dropdown');

    if (copyBtn) {
        copyBtn.addEventListener('click', function (event) {
            event.preventDefault();

            const url = this.getAttribute('data-url') || window.location.href;

            navigator.clipboard.writeText(url).then(() => {
                const aviso = document.getElementById('copiar');
                if (aviso) {
                    aviso.style.visibility = 'visible';
                    aviso.style.opacity = '1';

                    setTimeout(() => {
                        aviso.style.visibility = 'hidden';
                        aviso.style.opacity = '0';
                    }, 2000);
                }
            }).catch(err => {
                console.error('Erro ao copiar: ', err);
            });
        });
    }
    if (trigger) {
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            dropdown.classList.toggle('is-active');
        });

        document.addEventListener('click', () => {
            dropdown.classList.remove('is-active');
        });
    }
}